import '../styles/RecentLessonCard.css';

import { Box, Paper, Typography } from '@mui/material';
import PathwayLessonVm, { CourseLessonVm } from '../models/LessonVm';
import React, { MouseEvent } from 'react';

import { ContentType } from '../models/Pathway';
import Grid from '@mui/material/Unstable_Grid2';
import LessonAttemptText from './LessonAttemptText';
import LessonService from '../services/LessonService';
import Tooltip from '@mui/material/Tooltip';
import ZoneVm from '../models/ZoneVm';

interface RecentLessonCardProps {
  courseLesson?: CourseLessonVm;
  pathwayLesson?: PathwayLessonVm;
  contentType?: ContentType;
  onLaunchPathwayLesson?: (
    lessonWindow: Window,
    title: string,
    zonekey: number,
    pathkey: string,
    lessonkey: string,
    resultkey: string
  ) => void;
  onLaunchCourseLesson?: (lesson: CourseLessonVm) => void;
}

const RecentLessonCard = (props: RecentLessonCardProps) => {
  const course = props.contentType === 'course';
  const { title } = course ? props.courseLesson : props.pathwayLesson;

  const lessonAttempt = course
    ? props.courseLesson.latestPortfolioAttempt
    : undefined;
  const lessonType = course ? props.courseLesson.type : undefined;
  const completionType = course ? props.courseLesson.completionType : undefined;
  const status = course
    ? props.courseLesson.latestPortfolioAttempt?.status
    : LessonService.toStatus(props.pathwayLesson);

  const handleCourseLessonClick = (e: MouseEvent<HTMLDivElement>) => {
    props.onLaunchCourseLesson(props.courseLesson);
  };

  const getDistributionZone = (zones: ZoneVm[]) => {
    return zones.find((zone) => zone.isDistributionZone);
  };

  const handlePathwayLessonClick = () => {
    const lessonWindow = window.open();
    const distributionZone = getDistributionZone(props.pathwayLesson.zones);

    const { pathkey, lessonkey, results } = props.pathwayLesson;
    const zone = distributionZone || props.pathwayLesson.zones[0];
    props.onLaunchPathwayLesson(
      lessonWindow,
      title,
      zone.zonekey,
      pathkey,
      lessonkey,
      results[0].resultkey
    );
  };

  return (
    <Box
      className="box"
      onClick={course ? handleCourseLessonClick : handlePathwayLessonClick}
    >
      <Paper elevation={2} className="paper">
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          className="container-grid"
        >
          <Grid className="lesson-title-grid">
            <Tooltip title={title} arrow>
              <Typography variant="body1" className="block-with-text">
                {title}
              </Typography>
            </Tooltip>
          </Grid>
          <Grid className="attempt-title-grid">
            {course && lessonAttempt && (
              <Typography
                variant="body2"
                className="block-with-text"
                component="div"
              >
                <LessonAttemptText
                  lessonAttempt={lessonAttempt}
                  label="Attempt created:"
                />
              </Typography>
            )}
            <Typography
              variant="button"
              style={{ color: LessonService.getStatusColor(status) }}
            >
              {LessonService.toStatusText(status, lessonType, completionType)}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default RecentLessonCard;
